export default {
  FETCH_MOVIE: 'FETCH_MOVIE',
  FETCH_MOVIE_START: 'FETCH_MOVIE_START',
  FETCH_MOVIE_SUCCESS: 'FETCH_MOVIE_SUCCESS',
  FETCH_MOVIE_FAILURE: 'FETCH_MOVIE_FAILURE',
  FETCH_MOVIE_USER_STATE: 'FETCH_MOVIE_USER_STATE',
  FETCH_MOVIE_USER_STATE_START: 'FETCH_MOVIE_USER_STATE_START',
  FETCH_MOVIE_USER_STATE_SUCCESS: 'FETCH_MOVIE_USER_STATE_SUCCESS',
  FETCH_MOVIE_USER_STATE_FAILURE: 'FETCH_MOVIE_USER_STATE_FAILURE',
  SET_IS_MOVIE_FAVORITE: 'SET_IS_MOVIE_FAVORITE',
  SET_IS_MOVIE_FAVORITE_START: 'SET_IS_MOVIE_FAVORITE_START',
  SET_IS_MOVIE_FAVORITE_SUCCESS: 'SET_IS_MOVIE_FAVORITE_SUCCESS',
  SET_IS_MOVIE_FAVORITE_FAILURE: 'SET_IS_MOVIE_FAVORITE_FAILURE',
  SET_IS_MOVIE_IN_WATCHLIST: 'SET_IS_MOVIE_IN_WATCHLIST',
  SET_IS_MOVIE_IN_WATCHLIST_START: 'SET_IS_MOVIE_IN_WATCHLIST_START',
  SET_IS_MOVIE_IN_WATCHLIST_SUCCESS: 'SET_IS_MOVIE_IN_WATCHLIST_SUCCESS',
  SET_IS_MOVIE_IN_WATCHLIST_FAILURE: 'SET_IS_MOVIE_IN_WATCHLIST_FAILURE',
  RATE_MOVIE: 'RATE_MOVIE',
  RATE_MOVIE_START: 'RATE_MOVIE_START',
  RATE_MOVIE_SUCCESS: 'RATE_MOVIE_SUCCESS',
  RATE_MOVIE_FAILURE: 'RATE_MOVIE_FAILURE',
};
